module.exports = __webpack_public_path__ + "img/101.92fa107f.png";